import React from 'react';
import { MapPin } from 'lucide-react';
import { MOMENTS } from '../mock/mock';
import { LeafTopLeft, LeafBottomRight } from './Leaves';

export default function Moments() {
  return (
    <section id="pillanatok" className="relative pt-24 md:pt-32 pb-24 md:pb-32 bg-gradient-to-b from-[#0e2030] via-[#0d2336] to-[#0e2030] text-white overflow-hidden">
      {/* Leaf corners */}
      <LeafTopLeft className="absolute top-0 left-0 w-40 md:w-48 h-auto pointer-events-none opacity-70 z-[5]" />
      <LeafBottomRight className="absolute bottom-0 right-0 w-40 md:w-48 h-auto pointer-events-none opacity-70 z-[5]" />

      {/* Watermark */}
      <div aria-hidden className="absolute top-10 left-0 right-0 text-center pointer-events-none select-none">
        <span className="font-serif-display tracking-[0.4em] text-[120px] md:text-[180px] leading-none text-white/[0.04] uppercase">Pillanatok</span>
      </div>

      <div className="relative max-w-7xl mx-auto px-6">
        <div className="mb-14">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-2 h-2 rounded-full bg-[#2BA8C0]" />
            <span className="text-[12px] uppercase tracking-[0.3em] text-[#2BA8C0] font-medium">Projekt pillanatok</span>
          </div>
          <h2 className="font-serif-display text-4xl md:text-6xl text-white leading-[1.05] max-w-4xl">
            Egy könnyűszerkezetes ház<br />
            <span className="italic text-[#2BA8C0]">születése pillanatról pillanatra.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {MOMENTS.map((m) => (
            <article
              key={m.num}
              className="group relative rounded-3xl border border-white/10 bg-white/[0.03] backdrop-blur-sm overflow-hidden hover:border-[#2BA8C0]/40 transition-all duration-500"
            >
              {/* Header with number + tag */}
              <div className="flex items-start justify-between p-6 pb-4">
                <span className="font-serif-display text-[64px] leading-none text-white/85">{m.num}</span>
                <span className="px-3 py-1.5 rounded-full bg-white/10 border border-white/15 text-[10px] uppercase tracking-[0.2em] text-white/85">{m.tag}</span>
              </div>

              {/* Image */}
              <div className="relative mx-6 mb-6 aspect-[4/3] rounded-2xl overflow-hidden">
                <img src={m.image} alt={m.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
              </div>

              {/* Content */}
              <div className="px-6 pb-7">
                <h3 className="font-serif-display text-2xl text-white leading-tight mb-3">{m.title}</h3>
                <p className="text-white/70 text-[14px] leading-relaxed mb-5">{m.desc}</p>
                <div className="pt-4 border-t border-white/10 flex items-center gap-2 text-[#2BA8C0] text-[12px] uppercase tracking-wider">
                  <MapPin className="w-3.5 h-3.5" />
                  <span>{m.region}</span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-between gap-4 pt-8 border-t border-white/10">
          <div className="flex flex-wrap gap-x-5 gap-y-2 text-[13px] text-white/55">
            <span>Valós projekt</span>
            <span className="text-white/25">•</span>
            <span>Könnyűszerkezetes technológia</span>
            <span className="text-white/25">•</span>
            <span>Velencei-tó régió</span>
            <span className="text-white/25">•</span>
            <span>2025</span>
          </div>
          <a href="#survey" className="text-[14px] font-medium text-white hover:text-[#2BA8C0] transition-colors inline-flex items-center gap-2 group">
            Kezdje el a sajátját
            <span className="group-hover:translate-x-1 transition-transform">→</span>
          </a>
        </div>
      </div>
    </section>
  );
}
